import { CROSS_CLIENT_DEFAULT_CATEGORIES, CROSS_CLIENT_DEFAULT_ICONS, CrossClientDefault, CrossClientDefaultCategory } from '../../Defaults/crossClientDefaults'
import classNames from 'classnames'
import React, { useState } from 'react'
import { useAppSelector } from '../../../../store/hooks'
import { selectCrossClientLandingCompletedExecutions, selectCrossClientLandingRunningExecutions } from '../../../../store/crossClient/crossClientLanding'
import { CrossClientLandingDefaults } from '../Defaults/CrossClientLandingDefaults'
import { CrossClientLandingHistory } from '../History/CrossClientLandingHistory'

type CrossClientPillOption = 'History' | CrossClientDefaultCategory

export interface CrossClientLandingFooterProps {
  onDefaultSelected: (crossClientDefault: CrossClientDefault) => void
}

export const CrossClientLandingFooter: React.FC<CrossClientLandingFooterProps> = ({ onDefaultSelected }) => {
  const runningExecutions = useAppSelector(selectCrossClientLandingRunningExecutions)
  const completedExecutions = useAppSelector(selectCrossClientLandingCompletedExecutions)

  const hasExecution = runningExecutions.length || completedExecutions.length

  const [selectedPill, setSelectedPill] = useState<CrossClientPillOption>(completedExecutions.length ? 'History' : 'Featured')

  return (
    <div className='d-flex flex-column zocks-gap-2 w-100 zocks-mb-4'>
      <div className='d-flex gap-2 justify-content-center'>
        {hasExecution ? (
          <CrossClientPill title='History' selected={selectedPill === 'History'} onClick={() => setSelectedPill('History')} icon={'bi-clock-history'} />
        ) : null}
        {CROSS_CLIENT_DEFAULT_CATEGORIES.map((key: CrossClientDefaultCategory) => {
          const selected = selectedPill === key
          return <CrossClientPill key={key} title={key} selected={selected} icon={CROSS_CLIENT_DEFAULT_ICONS[key]} onClick={() => setSelectedPill(key)} />
        })}
      </div>
      {selectedPill === 'History' ? <CrossClientLandingHistory /> : <CrossClientLandingDefaults selectedCategory={selectedPill} onClick={onDefaultSelected} />}
    </div>
  )
}

interface CrossClientPillProps {
  title: string
  selected: boolean
  icon?: string
  onClick: () => void
}

const CrossClientPill: React.FC<CrossClientPillProps> = ({ title, selected, icon, onClick }) => {
  const [hovered, setHovered] = useState<boolean>(false)

  return (
    <div
      className={classNames('d-flex gap-2 px-2 py-1 align-items-center zocks-border-0.5 border border-1 bg-white cross-client-transition', {
        'zocks-text-primary zocks-bg-color-primary-light': selected,
        'zocks-border-color-gray-500': !selected && !hovered,
        'zocks-border-color-primary': selected || hovered,
      })}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      role='button'
    >
      {icon ? <i className={`bi ${icon}`} /> : null}

      <div className='paragraph-small medium'>{title}</div>
    </div>
  )
}
